"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDigraph = void 0;
const regex = /digraph([\s\S]*?)\}[\s]*?$/gm;
function parseDigraph(text) {
    const result = text.match(regex);
    return result || null;
}
exports.parseDigraph = parseDigraph;
//# sourceMappingURL=parse-digraph.js.map